import React, { useState, useEffect, useRef } from 'react';
import './DataFlowAnimation.css';

const DataFlowAnimation = () => {
  const [animationStarted, setAnimationStarted] = useState(false);
  const svgRef = useRef(null);

  // Animasyon başlatma
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationStarted(true);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

    // Veri kaynakları
  const dataSources = [
    { id: 'analytics', name: 'Google Analytics', icon: '/Google-Analytics-Logo.png', color: '#4285F4' },
    { id: 'ga', name: 'Google Ads', icon: '/google_ads-512.webp', color: '#FBBC05' },
    { id: 'meta', name: 'Meta Ads', icon: '/6033716.png', color: '#4267B2' },
    { id: 'tiktok', name: 'TikTok Ads', icon: '/download.png', color: '#69C9D0' }
  ];
  
  // Çıktı kanalları
  const outputChannels = [
    { id: 'analytics-out', name: 'Google Analytics', icon: '/Google-Analytics-Logo.png', color: '#4285F4', parent: 'ai' },
    { id: 'meta-out', name: 'Meta', icon: '/6033716.png', color: '#4267B2', parent: 'ai' },
    { id: 'tiktok-out', name: 'TikTok', icon: '/download.png', color: '#69C9D0', parent: 'ai' },
    { id: 'google-out', name: 'Google', icon: '/google_ads-512.webp', color: '#FBBC05', parent: 'ai' },
    { id: 'search-out', name: 'Search Console', icon: '/Google-Analytics-Logo.png', color: '#34A853', parent: 'customer' },
    { id: 'ads-out', name: 'Ads Optimization', icon: '/google_ads-512.webp', color: '#EA4335', parent: 'customer' }
  ];
  
  // Orta işlemciler
  const processors = [
    { id: 'database', name: 'Database', icon: '/database2.gif', x: 400, y: 300 },
    { id: 'ai', name: 'AI Engine', icon: '/digitalization2.gif', x: 650, y: 200, color: '#FF4500' },
    { id: 'customer', name: 'Customer Insights', icon: '/14rob.png', x: 650, y: 400, color: '#4A86E8' },
    { id: 'glowytics', name: 'Glowytics Platform', icon: '/logoicon.png', x: 900, y: 300, color: '#FF6B35' }
  ];
  
  return (
    <div className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          
          
        </div>
        
        {/* Mevcut GIF */}
        
        
        {/* Yeni interaktif SVG diyagram */}
        <div className="mt-16 mb-8 text-center">
          <h3 className="text-2xl font-bold text-gray-800">Interactive Data Flow Visualization</h3>
          <p className="text-gray-600 mt-2">Hover over elements to see details</p>
        </div>
        
        <div className="cool-diagram-container relative overflow-x-auto">
          <svg 
            ref={svgRef}
            width="1200" 
            height="600" 
            className="cool-diagram mx-auto"
            style={{ 
              background: 'linear-gradient(to bottom right, #f8fafc, #f1f5f9)',
              borderRadius: '12px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
            }}
          >
            {/* Arka plan grid */}
            <pattern id="smallGrid" width="20" height="20" patternUnits="userSpaceOnUse">
              <path d="M 20 0 L 0 0 0 20" fill="none" stroke="rgba(0, 0, 0, 0.03)" strokeWidth="0.5" />
            </pattern>
            <pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse">
              <rect width="100" height="100" fill="url(#smallGrid)" />
              <path d="M 100 0 L 0 0 0 100" fill="none" stroke="rgba(0, 0, 0, 0.05)" strokeWidth="1" />
            </pattern>
            <rect width="100%" height="100%" fill="url(#grid)" />

            {/* Sol üst köşeye Glowytics logosu */}
            <image 
              href="/Calisma-Yuzeyi-20@5x-4.png" 
              x="20" 
              y="20" 
              height="40" 
              width="150"
              className={`${animationStarted ? 'animate-fade-in' : ''}`}
              style={{ animationDelay: '0.2s' }}
            />
            
            {/* Veri kaynaklarından database'e çizgiler - tamamen yeni yaklaşım */}
            {dataSources.map((source, index) => {
              const startY = 200 + index * 70;
              const startX = 110; // Logo çemberinin kenarı (80 + 30)
              
              // Her logodan farklı bir Y noktasına
              let targetY;
              const endX = processors[0].x - 63; // Database'in sol kenarı
              
              if (index === 0) { // Google Analytics - üstten bağlan
                targetY = processors[0].y - 30; // Database'in üst kısmına
              } else if (index === 1) { // Google Ads - üst-yan
                targetY = processors[0].y - 15; 
              } else if (index === 2) { // Meta - alt-yan
                targetY = processors[0].y + 15;
              } else if (index === 3) { // TikTok - alttan
                targetY = processors[0].y + 30; // Database'in alt kısmına
              }
              
              // SVG yolu için daha basit bir tanım - düzgün eğriler için bezier kullanımı
              const pathData = `M ${startX} ${startY} 
                                H ${startX + 100} 
                                C ${startX + 200} ${startY}, ${endX - 80} ${targetY}, ${endX} ${targetY}`;
              
              return (
                <g key={`direct-path-${source.id}`}>
                  {/* Çizgi - RENKLER MAVİ YAPILDI */}
                  <path 
                    d={pathData}
                    fill="none"
                    stroke="#3b82f6" // Değiştirildi - Tüm çizgiler mavi (#3b82f6)
                    strokeWidth="2"
                    strokeDasharray={index % 2 === 0 ? "0" : "5,5"}
                    className={`path-line ${animationStarted ? 'animate-draw' : ''}`}
                    style={{ 
                      animationDelay: `${index * 0.2}s`,
                      animationDuration: '1.5s'
                    }}
                  />
                  
                  {/* Hareketli nokta - RENKLER MAVİ YAPILDI, HIZI YAVAŞLATILDI */}
                  <circle 
                    r="4" 
                    fill="#3b82f6" // Değiştirildi - Tüm noktalar mavi (#3b82f6)
                    className={`moving-dot ${animationStarted ? 'animate-move' : ''}`}
                    style={{ 
                      animationDelay: `${index * 0.2 + 0.5}s`,
                      animationDuration: '5s' // Değiştirildi - 3s'den 5s'ye (yavaşlatma)
                    }}
                  >
                    <animateMotion
                      path={pathData}
                      begin={`${index * 0.2 + 0.5}s`}
                      dur="5s" // Değiştirildi - 3s'den 5s'ye (yavaşlatma)
                      repeatCount="indefinite"
                    />
                  </circle>
                </g>
              );
            })}
            
            {/* Veri kaynakları */}
            {dataSources.map((source, index) => (
              <g 
                key={source.id} 
                className="node-group source-node"
                transform={`translate(80, ${200 + index * 70})`}
              >
                <circle 
                  r="30" 
                  fill="white" 
                  stroke="#e2e8f0" 
                  strokeWidth="2"
                  className={`node-circle ${animationStarted ? 'animate-pop' : ''}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                />
                <image 
                  href={source.icon} 
                  x="-20" 
                  y="-20" 
                  height="40" 
                  width="40"
                  className={`node-icon ${animationStarted ? 'animate-fade-in' : ''}`}
                  style={{ animationDelay: `${index * 0.1 + 0.3}s` }}
                />
              </g>
            ))}
            
            {/* İşlemciler */}
            {processors.map((processor, index) => (
              <g 
                key={processor.id} 
                className="node-group processor-node"
                transform={`translate(${processor.x}, ${processor.y})`}
              >
                {processor.id === 'database' ? (
                  // Database için özel stil - GIF kullanımı
                  <>
                    <circle 
                      r="63" 
                      fill="white" 
                      stroke="#bfdbfe" 
                      strokeWidth="6"
                      className={`database-border ${animationStarted ? 'animate-pulse' : ''}`}
                    />
                    <image 
                      href="/database2.gif" 
                      x="-54" 
                      y="-54" 
                      height="108" 
                      width="108"
                      className={`node-icon ${animationStarted ? 'animate-fade-in' : ''}`}
                      style={{ animationDelay: '1.6s' }}
                      clipPath="url(#circleClip)"
                    />
                    {/* Yuvarlak kırpma maskesi */}
                    <clipPath id="circleClip">
                      <circle r="54" cx="0" cy="0" />
                    </clipPath>
                    {/* Hafif parıltı efekti */}
                    <circle 
                      r="54" 
                      fill="none" 
                      stroke="#3b82f6" 
                      strokeWidth="3"
                      strokeOpacity="0.3"
                      className={`database-glow ${animationStarted ? 'animate-pulse' : ''}`}
                      style={{ animationDuration: '3s' }}
                    />
                  </>
                ) : processor.id === 'ai' ? (
                  // AI Engine için digitalization2.gif kullanımı - mavi çerçeve
                  <>
                    <circle 
                      r="50" 
                      fill="white" 
                      stroke="#3b82f6" // Değiştirildi - #FF4500'den #3b82f6'ya (mavi renk)
                      strokeWidth="4"
                      className={`node-circle ${animationStarted ? 'animate-pop' : ''}`}
                      style={{ animationDelay: `1.5s` }}
                    />
                    <image 
                      href="/digitalization2.gif" 
                      x="-40" 
                      y="-40" 
                      height="80" 
                      width="80"
                      className={`node-icon ${animationStarted ? 'animate-fade-in' : ''}`}
                      style={{ animationDelay: '1.7s' }}
                      clipPath="url(#aiClip)"
                    />
                    {/* Yuvarlak kırpma maskesi */}
                    <clipPath id="aiClip">
                      <circle r="40" cx="0" cy="0" />
                    </clipPath>
                    {/* Hafif parıltı efekti - renk mavi yapıldı */}
                    <circle 
                      r="40" 
                      fill="none" 
                      stroke="#3b82f6" // Değiştirildi - #FF4500'den #3b82f6'ya (mavi renk)
                      strokeWidth="2"
                      strokeOpacity="0.3"
                      className={`ai-glow ${animationStarted ? 'animate-pulse' : ''}`}
                      style={{ animationDuration: '3s' }}
                    />
                  </>
                ) : processor.id === 'customer' ? (
                  // Customer için 14rob.png kullanımı
                  <>
                    <circle 
                      r="78" 
                      fill="white" 
                      stroke="#4A86E8" 
                      strokeWidth="4"
                      className={`node-circle ${animationStarted ? 'animate-pop' : ''}`}
                      style={{ animationDelay: `1.5s` }}
                    />
                    <image 
                      href="/14rob.png" 
                      x="-62" 
                      y="-62" 
                      height="125" 
                      width="125"
                      className={`node-icon ${animationStarted ? 'animate-fade-in' : ''}`}
                      style={{ animationDelay: '1.7s' }}
                      clipPath="url(#customerClip)"
                    />
                    {/* Yuvarlak kırpma maskesi */}
                    <clipPath id="customerClip">
                      <circle r="62" cx="0" cy="0" />
                    </clipPath>
                    {/* Hafif parıltı efekti */}
                    <circle 
                      r="62" 
                      fill="none" 
                      stroke="#4A86E8" 
                      strokeWidth="2"
                      strokeOpacity="0.3"
                      className={`customer-glow ${animationStarted ? 'animate-pulse' : ''}`}
                      style={{ animationDuration: '3s' }}
                    />
                  </>
                ) : processor.id === 'glowytics' ? (
                  // Glowytics için logoicon.png kullanımı - database gibi animasyonlu, mavi renkte
                  <>
                    <circle 
                      r="63" 
                      fill="white" 
                      stroke="#3b82f6" // Mavi renk (değiştirildi)
                      strokeWidth="6"
                      className={`database-border ${animationStarted ? 'animate-pulse' : ''}`}
                    />
                    <image 
                      href="/logoicon.png" 
                      x="-54" 
                      y="-54" 
                      height="108" 
                      width="108"
                      className={`node-icon ${animationStarted ? 'animate-fade-in' : ''}`}
                      style={{ animationDelay: '1.6s' }}
                      clipPath="url(#glowyticsClip)"
                    />
                    {/* Yuvarlak kırpma maskesi */}
                    <clipPath id="glowyticsClip">
                      <circle r="54" cx="0" cy="0" />
                    </clipPath>
                    {/* Hafif parıltı efekti - mavi renkte */}
                    <circle 
                      r="54" 
                      fill="none" 
                      stroke="#3b82f6" // Mavi renk (değiştirildi)
                      strokeWidth="3"
                      strokeOpacity="0.3"
                      className={`database-glow ${animationStarted ? 'animate-pulse' : ''}`}
                      style={{ animationDuration: '3s' }}
                    />
                  </>
                ) : (
                  // Varsayılan stil (diğer işlemciler için)
                  <>
                    <circle 
                      r="40" 
                      fill="white" 
                      stroke={processor.color || '#3B82F6'} 
                      strokeWidth="2"
                      className={`node-circle ${animationStarted ? 'animate-pop' : ''}`}
                      style={{ animationDelay: `1.5s` }}
                    />
                    <circle 
                      r="30" 
                      fill={`${processor.color}10` || '#3B82F610'} 
                      stroke={processor.color || '#3B82F6'} 
                      strokeWidth="1"
                      className={`node-inner-circle ${animationStarted ? 'animate-pulse' : ''}`}
                      style={{ animationDelay: `1.7s` }}
                    />
                    <text 
                      x="0" 
                      y="0" 
                      textAnchor="middle" 
                      dominantBaseline="middle"
                      fill={processor.color || '#3B82F6'}
                      fontWeight="bold"
                      fontSize="24"
                      className={`node-emoji ${animationStarted ? 'animate-fade-in' : ''}`}
                      style={{ animationDelay: `1.9s` }}
                    >
                      {processor.id === 'ai' ? '🧠' : '👥'}
                    </text>
                  </>
                )}
              </g>
            ))}
            
            {/* Çıktı kanalları */}
            {outputChannels.map((channel, index) => (
              <g 
                key={channel.id} 
                className="node-group output-node"
                transform={`translate(1120, ${150 + index * 70})`}
              >
                <circle 
                  r="30" 
                  fill="white" 
                  stroke="#e2e8f0" 
                  strokeWidth="2"
                  className={`node-circle ${animationStarted ? 'animate-pop' : ''}`}
                  style={{ animationDelay: `${2.5 + index * 0.1}s` }}
                />
                <image 
                  href={channel.icon} 
                  x="-20" 
                  y="-20" 
                  height="40" 
                  width="40"
                  className={`node-icon ${animationStarted ? 'animate-fade-in' : ''}`}
                  style={{ animationDelay: `${2.5 + index * 0.1 + 0.2}s` }}
                />
              </g>
            ))}
            
            {/* Database'den direkt iki ayrı çizgi çıksın */}
            <g key="database-to-processors">
              {/* Database'den AI Engine'e (Beyin) çizgi - RENGİ MAVİ YAPILDI */}
              <path 
                d={`M ${processors[0].x + 63} ${processors[0].y - 20} 
                    C ${processors[0].x + 100} ${processors[0].y - 20}, 
                      ${processors[1].x - 100} ${processors[1].y}, 
                      ${processors[1].x - 40} ${processors[1].y}`}
                fill="none"
                stroke="#3b82f6" // Değiştirildi - #FF4500'den #3b82f6'ya
                strokeWidth="2"
                className={`path-line ${animationStarted ? 'animate-draw' : ''}`}
                style={{ 
                  animationDelay: `1.8s`,
                  animationDuration: '1s'
                }}
              />
              
              {/* Database'den Customer Insights'a (İnsan) çizgi - RENGİ MAVİ YAPILDI */}
              <path 
                d={`M ${processors[0].x + 63} ${processors[0].y + 20} 
                    C ${processors[0].x + 100} ${processors[0].y + 20}, 
                      ${processors[2].x - 100} ${processors[2].y}, 
                      ${processors[2].x - 40} ${processors[2].y}`}
                fill="none"
                stroke="#3b82f6" // Değiştirildi - #4A86E8'den #3b82f6'ya
                strokeWidth="2"
                className={`path-line ${animationStarted ? 'animate-draw' : ''}`}
                style={{ 
                  animationDelay: `1.8s`,
                  animationDuration: '1s'
                }}
              />
              
              {/* Hareketli noktalar - RENKLERİ MAVİ YAPILDI, HIZLARI YAVAŞLATILDI */}
              <circle 
                r="4" 
                fill="#3b82f6" // Değiştirildi - #FF4500'den #3b82f6'ya
                className={`moving-dot ${animationStarted ? 'animate-move' : ''}`}
                style={{ 
                  animationDelay: `2s`,
                  animationDuration: '4s', // Değiştirildi - 2s'den 4s'ye (yavaşlatma)
                  animationIterationCount: 'infinite'
                }}
              >
                <animateMotion
                  path={`M ${processors[0].x + 63} ${processors[0].y - 20} 
                         C ${processors[0].x + 100} ${processors[0].y - 20}, 
                           ${processors[1].x - 100} ${processors[1].y}, 
                           ${processors[1].x - 40} ${processors[1].y}`}
                  begin="2s"
                  dur="4s" // Değiştirildi - 2s'den 4s'ye (yavaşlatma)
                  repeatCount="indefinite"
                />
              </circle>
              
              <circle 
                r="4" 
                fill="#3b82f6" // Değiştirildi - #4A86E8'den #3b82f6'ya
                className={`moving-dot ${animationStarted ? 'animate-move' : ''}`}
                style={{ 
                  animationDelay: `2.1s`,
                  animationDuration: '4s', // Değiştirildi - 2s'den 4s'ye (yavaşlatma)
                  animationIterationCount: 'infinite'
                }}
              >
                <animateMotion
                  path={`M ${processors[0].x + 63} ${processors[0].y + 20} 
                         C ${processors[0].x + 100} ${processors[0].y + 20}, 
                           ${processors[2].x - 100} ${processors[2].y}, 
                           ${processors[2].x - 40} ${processors[2].y}`}
                  begin="2.1s"
                  dur="4s" // Değiştirildi - 2s'den 4s'ye (yavaşlatma)
                  repeatCount="indefinite"
                />
              </circle>
            </g>
            
            {/* Database'den Glowytics İkonuna çizgiler */}
            <g key="processors-to-glowytics">
              {/* AI Engine'den Glowytics'e çizgi - RENGİ MAVİ YAPILDI */}
              <path 
                d={`M ${processors[1].x + 50} ${processors[1].y} 
                    C ${processors[1].x + 100} ${processors[1].y}, 
                      ${processors[3].x - 100} ${processors[1].y}, 
                      ${processors[3].x - 60} ${processors[3].y - 30}`}
                fill="none"
                stroke="#3b82f6" // Değiştirildi - #FF4500'den #3b82f6'ya
                strokeWidth="2"
                className={`path-line ${animationStarted ? 'animate-draw' : ''}`}
                style={{ 
                  animationDelay: `2.3s`,
                  animationDuration: '1s'
                }}
              />
              
              {/* Customer Insights'dan Glowytics'e çizgi - RENGİ MAVİ YAPILDI */}
              <path 
                d={`M ${processors[2].x + 78} ${processors[2].y} 
                    C ${processors[2].x + 100} ${processors[2].y}, 
                      ${processors[3].x - 100} ${processors[2].y}, 
                      ${processors[3].x - 60} ${processors[3].y + 30}`}
                fill="none"
                stroke="#3b82f6" // Değiştirildi - #4A86E8'den #3b82f6'ya
                strokeWidth="2"
                className={`path-line ${animationStarted ? 'animate-draw' : ''}`}
                style={{ 
                  animationDelay: `2.3s`,
                  animationDuration: '1s'
                }}
              />
              
              {/* Hareketli noktalar - RENKLERİ MAVİ YAPILDI, HIZLARI YAVAŞLATILDI */}
              <circle 
                r="4" 
                fill="#3b82f6" // Değiştirildi - #FF4500'den #3b82f6'ya
                className={`moving-dot ${animationStarted ? 'animate-move' : ''}`}
                style={{ 
                  animationDelay: `2.4s`,
                  animationDuration: '4s', // Değiştirildi - 2s'den 4s'ye (yavaşlatma)
                  animationIterationCount: 'infinite'
                }}
              >
                <animateMotion
                  path={`M ${processors[1].x + 50} ${processors[1].y} 
                         C ${processors[1].x + 100} ${processors[1].y}, 
                           ${processors[3].x - 100} ${processors[1].y}, 
                           ${processors[3].x - 60} ${processors[3].y - 30}`}
                  begin="2.4s"
                  dur="4s" // Değiştirildi - 1.8s'den 4s'ye (yavaşlatma)
                  repeatCount="indefinite"
                />
              </circle>
              
              <circle 
                r="4" 
                fill="#3b82f6" // Değiştirildi - #4A86E8'den #3b82f6'ya
                className={`moving-dot ${animationStarted ? 'animate-move' : ''}`}
                style={{ 
                  animationDelay: `2.4s`,
                  animationDuration: '4s', // Değiştirildi - 2s'den 4s'ye (yavaşlatma)
                  animationIterationCount: 'infinite'
                }}
              >
                <animateMotion
                  path={`M ${processors[2].x + 78} ${processors[2].y} 
                         C ${processors[2].x + 100} ${processors[2].y}, 
                           ${processors[3].x - 100} ${processors[2].y}, 
                           ${processors[3].x - 60} ${processors[3].y + 30}`}
                  begin="2.4s"
                  dur="4s" // Değiştirildi - 1.8s'den 4s'ye (yavaşlatma)
                  repeatCount="indefinite"
                />
              </circle>
              
              {/* Database'den doğrudan Glowytics'e çizgi - RENK ZATEN MAVİ (#3b82f6) */}
              <path 
                d={`M ${processors[0].x + 63} ${processors[0].y} 
                    H ${(processors[0].x + processors[3].x) / 2}
                    C ${(processors[0].x + processors[3].x) / 2 + 50} ${processors[0].y}, 
                      ${processors[3].x - 100} ${processors[3].y}, 
                      ${processors[3].x - 60} ${processors[3].y}`}
                fill="none"
                stroke="#3b82f6" // Bu zaten mavi, değiştirilmedi
                strokeWidth="2"
                className={`path-line ${animationStarted ? 'animate-draw' : ''}`}
                style={{ 
                  animationDelay: `2.5s`,
                  animationDuration: '1s'
                }}
              />
              
              <circle 
                r="4" 
                fill="#3b82f6" // Bu zaten mavi, değiştirilmedi
                className={`moving-dot ${animationStarted ? 'animate-move' : ''}`}
                style={{ 
                  animationDelay: `2.6s`,
                  animationDuration: '4.4s', // Değiştirildi - 2.2s'den 4.4s'ye (yavaşlatma)
                  animationIterationCount: 'infinite'
                }}
              >
                <animateMotion
                  path={`M ${processors[0].x + 63} ${processors[0].y} 
                         H ${(processors[0].x + processors[3].x) / 2}
                         C ${(processors[0].x + processors[3].x) / 2 + 50} ${processors[0].y}, 
                           ${processors[3].x - 100} ${processors[3].y}, 
                           ${processors[3].x - 60} ${processors[3].y}`}
                  begin="2.6s"
                  dur="4.4s" // Değiştirildi - 2.2s'den 4.4s'ye (yavaşlatma)
                  repeatCount="indefinite"
                />
              </circle>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default DataFlowAnimation;